import CoordinateCardPop from '@/components/CoordinateCardPop';
import Map from '@/components/Map';
import PlaceCard from '@/components/PlaceCard';
import { setUserCity } from '@/services/storage-service';
import useLocationStore from '@/store/locationStore';
import { usePlaceStore } from '@/store/place';
import { Place } from '@/types/type';
import * as Location from 'expo-location';
import React, { useEffect, useState } from 'react';
import { Alert, TouchableOpacity, View } from 'react-native';

const Places = () => {
  const [currentSelectedPlace, setCurrentSelectedPlace] = useState<Place | null>(null);
  const { destinationCity, setDestinationLocation } = useLocationStore();
  const { places, setPlaces, setSelectedPlace, selectedPlace } = usePlaceStore();
  const [currentSelectedCoordinate, setCurrentSelectedCoordinate] = useState<{
    latitude: number;
    longitude: number;
  } | null>(null);

  useEffect(() => {
    (async () => {
      let { status } = await Location.requestForegroundPermissionsAsync();
      if (status !== 'granted') {
        Alert.alert('Permission Denied', 'Allow the app to access your location.');
        return;
      }

      let location = await Location.getCurrentPositionAsync({});
      let addressArray = await Location.reverseGeocodeAsync({
        latitude: location.coords.latitude,
        longitude: location.coords.longitude,
      });

      if (addressArray.length > 0) {
        const { name, city, region } = addressArray[0];
        const address = `${name}, ${region}`;
        const userCity = city || '';
        await setUserCity(userCity);

        if (location.coords.latitude && location.coords.longitude) {
          setDestinationLocation(location.coords.latitude, location.coords.longitude);
        }
      }
    })();
  }, []);

  const handleMarkerSelect = (place: Place) => {
    setCurrentSelectedPlace(place);
    setSelectedPlace(place);
  };

  const handleMapPress = (coordinate: { latitude: number; longitude: number }) => {
    setCurrentSelectedPlace(null);
    setSelectedPlace(null);
    setCurrentSelectedCoordinate(coordinate);
  };

  return (
    <View className="h-full w-full bg-transparent">
      <Map onMarkerSelect={handleMarkerSelect} onPress={handleMapPress} />

      {currentSelectedPlace && (
        <View className="absolute bottom-12 z-1 items-center center">
          <PlaceCard place={currentSelectedPlace} />
        </View>
      )}

      {currentSelectedCoordinate && currentSelectedPlace == null && (
        <TouchableOpacity className="absolute bottom-80 z-1 items-center center">
          <CoordinateCardPop coordinate={currentSelectedCoordinate} />
        </TouchableOpacity>
      )}
    </View>
  );
};

export default Places;
